import { WATCHES_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformAggWatchesToLegacyWatches = (watch) => ({
	watchCount: watch.count != null ? Number(watch.count) : 0,
	isWatching: watch.isWatching ?? false,
});

export const transformAggWatchesToLegacyField: FieldTransformer<typeof WATCHES_TYPE> = (node) => {
	if (node.type !== WATCHES_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: node.watch ? transformAggWatchesToLegacyWatches(node.watch) : null,
		schema: {
			configuration: null,
			custom: null,
			items: null,
			renderer: null,
			system: WATCHES_TYPE,
			type: WATCHES_TYPE,
		},
	};
};
